import { useFormatPrice } from '@packages/shared';

export type UseFormatedPriceTypes = 'PRODUCT' | 'APLUS' | 'ATB' | 'INSTALLMENTCALCULATOR';
export type FormatPricePrice = Parameters<ReturnType<typeof useFormatPrice>['formatPrice']>[0];
export type FormatPriceCurrency = Parameters<ReturnType<typeof useFormatPrice>['formatPrice']>[1];

function getPrice(price: FormatPricePrice, type: UseFormatedPriceTypes) {
  switch (type) {
    case 'PRODUCT':
    case 'ATB': {
      return price;
    }
    case 'APLUS':
    case 'INSTALLMENTCALCULATOR': {
      return Math.round(price * 100);
    }
    default: {
      return price;
    }
  }
}

export const useFormatedPrice = (type: UseFormatedPriceTypes) => {
  const { formatPrice } = useFormatPrice();

  return (price: FormatPricePrice, currency: FormatPriceCurrency) =>
    formatPrice(getPrice(price, type), currency);
};
